import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";

const FirstCard = ({ input, renderBody }) => {
  return (
    <div className="row g-4">
      {input.map((item, idx) => (
        <div key={item.id || idx} className="col-12 col-md-6">
          <div className="card first-execution-card h-100 border-0 shadow-sm rounded-4 p-4 bg-white">
            <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
              <span className="composer-badge-pill">
                {item.composer}
              </span>
              <FontAwesomeIcon icon={faMusic} className="text-warning opacity-75" />
            </div>

            <div className="first-piece-body text-start">
              {renderBody(item.piece)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FirstCard;
